import { parse } from 'query-string';
import { History } from 'history';

export function getFromHistory(history: History, fieldName: string): string {
  const search = parse(history.location.search);
  const result = search[fieldName] as string;
  return result;
}
